import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { FormResponse } from '../../../lib/models/dto/form-response-dto';
import { ApplicationFormStore } from '../../shared/services/application-form-store';
import { Kfi } from '../models/kfi.model';

@Injectable()
export class KfiStore extends ApplicationFormStore {
  private _kfiResponse = new FormResponse<Kfi>();
  private kfiDataSubject$ = new BehaviorSubject<FormResponse<Kfi>>(new FormResponse<Kfi>());
  public kfiId: string;

  constructor() {
    super();
    this.dataObservable = this.kfiDataSubject$.asObservable();
  }

  set kfiResponse(kfiResponse: FormResponse<Kfi>) {
    this._kfiResponse = kfiResponse;
    this.validationErrors = kfiResponse.ValidationErrors;
    this.isSubmitted = kfiResponse.IsSubmitted;
    this.kfiDataSubject$.next(kfiResponse);
  }

  get kfiResponse(): FormResponse<Kfi> {
    return this._kfiResponse;
  }
}
